import { SEARCH_CONFIG } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";


interface PropDesc {
    title_en: string,
    title_fr: string,
    code: string
}

interface YearBuiltTotalArea {
    "maxYear": number,
    "minYear": number,
    "stepSize": number,
    "minRange": number,
    "maxRange": number,
    "smallStepSizeBreakPoint": number,
    "smallStep": number,
    "largeStep": number
}

interface CommDropDown {
    "property_cd": string | number,
    "property_cd_desc": string
}

export interface SearchConfigResponse extends Record<string, unknown> {
    loading: false,
    error: false,
    "codes"?: Array<string | number>,
    "LH"?: Array<string | number>,
    "FH"?: Array<string | number>,
    "SD"?: Array<string | number>,
    "SFD"?: Array<string | number>,
    "WF"?: Array<string | number>,
    "PP"?: Array<string | number>,
    "RCI"?: Array<string | number>,
    "MH"?: Array<string | number>,
    "CONDO"?: Array<string | number>,
    "dropDownConfig"?: {
        "prop_desc"?: Array<PropDesc>,
        "yearBuilt"?: YearBuiltTotalArea,
        "totalArea"?: YearBuiltTotalArea
        },
    "showSales"?: Array<number>,
    "comm_dropdown"?: Array<CommDropDown>
    
}

// Define an initial state value for the app
const initialState: SearchConfigResponse = {
    loading: false,
    error: false,
}


function SearchConfigReducer(state = initialState, action: AppAction | AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case SEARCH_CONFIG.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case SEARCH_CONFIG.SUCCESS:
            return {
                ...state,
                ...payload,
                loading: false,
                error: false

            }
        case SEARCH_CONFIG.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        default:
            return state
    }
}

export default SearchConfigReducer;